import { configureStore } from '@reduxjs/toolkit';
const configStore = (rootReducer, initialState = {}, middlewares = []) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
        devTools: process.env.NODE_ENV !== 'production',
    });
};
export default configStore;
